import {
  DashboardContentWrapper,
  DashboardPageWrapper,
  DashboardSystemsWrapper,
} from '@pages/DashboardPage.styles';
import PageTitleBlock from '@organisms/PageTitleBlock';
import Button from '@atoms/Button';
import {AddAlt, BusinessMetrics} from '@carbon/icons-react';
import PageSubtitleBlock from '@organisms/PageSubtitleBlock';
import PageSubtitleTextBlock from '@molecules/PageSubtitleTextBlock';
import EmptyBlock from '@molecules/EmptyBlock';
import {theme} from '@styles/theme';
import {useEffect, useState} from 'react';
import SystemCard from '@organisms/SystemCard';
import {
  PageSubtitleLegendMark,
  PageSubtitleLegendWrapper,
} from '@organisms/PageSubtitleBlock.styles';
import Text from '@atoms/Text';
import AddEditSystemModal from '@organisms/modals/AddEditSystemModal';
import {useDispatch, useSelector} from 'react-redux';
import {systems, getSystems} from '@store/slices/systems';
import {AppDispatch, RootState} from '@store';
import {getUsers} from '@store/slices/users';
import {IDLE, PENDING} from '@constants/loadingState';
import {ISystem} from '@types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {formatLastUpdate} from '@utils/common';
import {EUserRoles} from "@constants/usersRoles";

export const DashboardPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    loading,
    addLoading,
    editLoading,
    deleteLoading,
    deleteSystemLoading,
    editSystemLoading,
  } = useSelector((state: RootState) => state.systems);
  const {inviteUserLoading} = useSelector((state: RootState) => state.users);
  const systemsArr: ISystem[] = useSelector(systems);
  const [addSystemShow, setAddSystemShow] = useState(false);
  const systemRole = useSelector((state: RootState) => state.profile.profile?.role_id);

  useEffect(() => {
    dispatch(getSystems({}));
    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (
      addLoading === IDLE &&
      editLoading === IDLE &&
      deleteLoading === IDLE &&
      deleteSystemLoading === IDLE &&
      editSystemLoading === IDLE
    ) {
      dispatch(getSystems({}));
    }
  }, [addLoading, editLoading, deleteLoading, deleteSystemLoading, editSystemLoading]);

  useEffect(() => {
    if (inviteUserLoading === IDLE) {
      dispatch(getUsers({}));
    }
  }, [inviteUserLoading]);

  return (
    <DashboardPageWrapper>
      <PageTitleBlock
        title="Тестовое покрытие всех систем"
        buttons={[
          <Button
            key={'add-system-title'}
            title="Добавить систему"
            iconElement={<AddAlt />}
            variant="filled"
            onClick={() => setAddSystemShow(true)}
            disabled={systemRole === EUserRoles.BASE_USER}
          />,
        ]}
      />
      <PageSubtitleBlock
        elementsToLeft={[
          <PageSubtitleTextBlock
            title="Всего систем:"
            text={`${systemsArr.length}`}
            key="all-systems-count"
          />,
          systemsArr.length ? (
            <PageSubtitleTextBlock
              title="Последнее изменение"
              text={`${formatLastUpdate(systemsArr[0].last_update || '')}`}
              key="last-change"
            />
          ) : (
            <></>
          ),
        ]}
        elementsToRight={
          systemsArr.length
            ? [
                <PageSubtitleLegendWrapper key="manual-legend">
                  <PageSubtitleLegendMark color={theme.colors.manual00} />
                  <Text
                    text="Ручное тестирование"
                    type="tinyR"
                    color={theme.colors.basic02}
                  />
                </PageSubtitleLegendWrapper>,
                <PageSubtitleLegendWrapper key="auto-legend">
                  <PageSubtitleLegendMark color={theme.colors.auto00} />
                  <Text
                    text="Автоматизированное"
                    type="tinyR"
                    color={theme.colors.basic02}
                  />
                </PageSubtitleLegendWrapper>,
              ]
            : []
        }
      />
      <DashboardContentWrapper>
        <DashboardSystemsWrapper>
          {loading === PENDING &&
            [...Array(3)].map(i => (
              <Skeleton
                key={`system-card-skeleton-${i}`}
                width={334}
                height={166}
                borderRadius={theme.roundedBig}
              />
            ))}
          {!!systemsArr.length &&
            loading === IDLE &&
            systemsArr.map(system => {
              return <SystemCard system={system} key={system.id} />;
            })}
        </DashboardSystemsWrapper>
        {!systemsArr.length && loading === IDLE && (
          <EmptyBlock
            icon={<BusinessMetrics size={32} color={theme.colors.accent00} />}
            text="Здесь пусто. Добавьте систему и редакторов
            для администрирования состояния тестового покрытия."
          />
        )}
      </DashboardContentWrapper>
      <AddEditSystemModal
        isOpened={addSystemShow}
        onCloseRequest={() => setAddSystemShow(false)}
      />
    </DashboardPageWrapper>
  );
};

export default DashboardPage;
